var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 16,
    viewBox: "0 0 52 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37584 16C6.15443 16 4.024 15.1571 2.45323 13.6569C0.882454 12.1566 0 10.1217 0 8C0 5.87827 0.882454 3.84344 2.45323 2.34314C4.024 0.842853 6.15443 0 8.37584 0H43.6242C45.8456 0 47.976 0.842853 49.5468 2.34314C51.1175 3.84344 52 5.87827 52 8C52 10.1217 51.1175 12.1566 49.5468 13.6569C47.976 15.1571 45.8456 16 43.6242 16H8.37584Z",
    fill: "url(#paint0_linear_21_213)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_213",
    x1: 0,
    y1: 16,
    x2: 52,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF236C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPill);
export default __webpack_public_path__ + "static/media/logoPill.a5d3bfdded9d33ec2e81b89d4bf41a81.svg";
export { ForwardRef as ReactComponent };